import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { refreshTokenEventEmitter } from "../../api/sessionEvents";
import { logout } from "../../api/api_methods";

export default function SessionExpiryDialog() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleShow = useCallback((evt) => {
    const detail = evt?.detail || {};
    setMessage(detail.message || "Your session has expired. Please login again.");
    setOpen(true);
  }, []);

  useEffect(() => {
    refreshTokenEventEmitter.addEventListener("show-refresh-token-popup", handleShow);
    return () => {
      refreshTokenEventEmitter.removeEventListener("show-refresh-token-popup", handleShow);
    };
  }, [handleShow]);

  const handleLoginAgain = async () => {
    try {
      await logout();
      localStorage.removeItem("user");
      sessionStorage.clear();
    } catch (e) {}
    setOpen(false);
    navigate("/");
    // Hard redirect fallback to ensure fresh session state
    setTimeout(() => {
      try {
        window.location.assign("/");
      } catch (e) {}
    }, 50);
  };

  if (!open) return null;

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    }}>
      <div style={{
        background: "#ffffff",
        borderRadius: 12,
        width: "min(92vw, 420px)",
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        padding: 20,
      }}>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Session expired</div>
        <div style={{ fontSize: 14, color: "#444", marginBottom: 20 }}>{message}</div>
        <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
          <button
            onClick={handleLoginAgain}
            style={{
              background: "#111827",
              border: "none",
              color: "#fff",
              padding: "8px 14px",
              borderRadius: 8,
              cursor: "pointer",
            }}
          >
            Login again
          </button>
        </div>
      </div>
    </div>
  );
}



